import React from 'react';
import ReactDOM from 'react-dom';
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/font.css";import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

